/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Bundesland {
    Niederoesterreich = 'Niederoesterreich',
    Oberoesterreich = 'Oberoesterreich',
    Steiermark = 'Steiermark',
    Kaernten = 'Kaernten',
    Salzburg = 'Salzburg',
    Tirol = 'Tirol',
    Vorarlberg = 'Vorarlberg',
    Burgenland = 'Burgenland',
    Wien = 'Wien'
  }

    export const BundeslandTranslocoMap: Record<Bundesland, string> = {
    [Bundesland.Niederoesterreich]: 'bundesland.niederoesterreich',
    [Bundesland.Oberoesterreich]: 'bundesland.oberoesterreich',
    [Bundesland.Steiermark]: 'bundesland.steiermark',
    [Bundesland.Kaernten]: 'bundesland.kaernten',
    [Bundesland.Salzburg]: 'bundesland.salzburg',
    [Bundesland.Tirol]: 'bundesland.tirol',
    [Bundesland.Vorarlberg]: 'bundesland.vorarlberg',
    [Bundesland.Burgenland]: 'bundesland.burgenland',
    [Bundesland.Wien]: 'bundesland.wien',
    };

    export const BundeslandOptions = [
  { value: Bundesland.Niederoesterreich, labelKey: 'bundesland.niederoesterreich' },
  { value: Bundesland.Oberoesterreich, labelKey: 'bundesland.oberoesterreich' },
  { value: Bundesland.Steiermark, labelKey: 'bundesland.steiermark' },
  { value: Bundesland.Kaernten, labelKey: 'bundesland.kaernten' },
  { value: Bundesland.Salzburg, labelKey: 'bundesland.salzburg' },
  { value: Bundesland.Tirol, labelKey: 'bundesland.tirol' },
  { value: Bundesland.Vorarlberg, labelKey: 'bundesland.vorarlberg' },
  { value: Bundesland.Burgenland, labelKey: 'bundesland.burgenland' },
  { value: Bundesland.Wien, labelKey: 'bundesland.wien' },
    ];

